import { Checkbox, Input, Button, Select } from "antd";
import React, { useState, useRef } from "react";

import { useSearchContext } from "./contexts/searchcontext.ts";
import Helpers from "../services/helpers";

const getDefaultValue = (fieldName, queryParams) => {
  switch (fieldName) {
    case "players":
      return queryParams.players || [];
    case "sets":
      return queryParams.sets || [];
    case "variations":
      return queryParams.variations || [];
    default:
      return [];
  }
};

const SELECT_ITEM_HEIGHT = 32;

const OptionList = ({
  heading,
  fieldName,
  selectionsChanged,
  hideByDefault,
  hideSearch,
  filterable,
  queryParams,
  nSelected,
  limit,
  type,
  maxSelectVisible = 0,
}) => {
  const [searchFilter, setSearchFilter] = useState("");
  const searchContext = useSearchContext();

  const selectionChanged = (e, item) => {
    const existing = searchContext[fieldName + "Selected"];
    let newItemsSelected = [...existing];

    if (e.target.checked) {
      newItemsSelected.push(item);
    } else {
      newItemsSelected = newItemsSelected.filter((item) => item.value !== e.target.name);
    }

    selectionsChanged(fieldName, newItemsSelected);
  };

  const selectionChangedSelect = (items) => {
    const arr = filterable ? searchContext[fieldName + "Available"] : searchContext[fieldName];
    const filterSelectedOptions = (arr) => arr.filter(filterItems).filter((v) => items.includes(v.value));

    selectionsChanged(fieldName, filterSelectedOptions(arr));
  };

  const isPlayerFilter = fieldName === "players";
  const textInput = useRef();

  const isSelected = (value) => {
    return searchContext[fieldName + "Selected"].some((item) => item.value === value);
  };

  const filterItems = ({ label, value }) => {
    if (isSelected(value)) {
      return true;
    }
    if (searchFilter === "") {
      return !hideByDefault;
    }
    let use = label;
    if (heading === "players") {
      const match = searchContext.playersOriginal.find((p) => p.id == value);
      if (match && match.alias) use += ` ${match.alias}`;
    }

    return Helpers.sciFilter(searchFilter, use);
  };

  let allItems = [];
  if (filterable) {
    allItems = searchContext[fieldName + "Available"].filter(filterItems);
  } else {
    allItems = searchContext[fieldName].filter(filterItems);
  }

  // // Sort grades a special way
  // if (fieldName === 'grades') {
  // 	allItems = sortBySearchGrades(allItems);
  // }

  let AllItemElements;

  if (type === "select") {
    AllItemElements = (
      <Select
        allowClear
        mode="multiple"
        value={searchContext[fieldName + "Selected"].map(({ value }) => value)}
        onChange={selectionChangedSelect}
        filterOption={Helpers.filterOption}
        style={{ marginBottom: 12, width: "100%" }}
        {...(maxSelectVisible > 0
          ? {
              listHeight: maxSelectVisible * SELECT_ITEM_HEIGHT,
              listItemHeight: SELECT_ITEM_HEIGHT,
            }
          : {})}
      >
        {allItems.map(({ label, value }) => (
          <Select.Option
            key={`${heading}-${value}`}
            value={value}
            disabled={limit && nSelected >= limit ? (isSelected(value) ? false : true) : false}
          >
            {label}
          </Select.Option>
        ))}
      </Select>
    );
  } else {
    AllItemElements = allItems.map(({ label, value, notes }) => {
      return (
        <div key={value}>
          <Checkbox
            name={value}
            disabled={!isSelected(value) && limit && nSelected >= limit}
            checked={isSelected(value)}
            onChange={(e) => selectionChanged(e, { label, value, notes })}
          >
            {label}
          </Checkbox>
        </div>
      );
    });
  }

  const setFilter = (event) => {
    setSearchFilter(event.target.value);
  };

  let selectedItems = null;
  // FIXME: `selectedItems` never used
  if (isPlayerFilter) selectedItems = searchContext[`${fieldName}Selected`]; // eslint-disable-line

  const focusAndClearSearch = () => {
    setSearchFilter("");
    textInput.current.focus();
  };

  const defaultValue = getDefaultValue(fieldName, queryParams);

  return (
    <div style={{ marginBottom: 12 }}>
      {!hideSearch && (
        <Input.Search
          ref={textInput}
          value={searchFilter}
          defaultValue={defaultValue}
          style={{ marginBottom: 8 }}
          placeholder={"Search " + heading}
          onChange={setFilter}
        />
      )}

      {hideByDefault && !searchFilter && (
        <div
          style={{
            marginTop: 2,
            marginBottom: 6,
            marginLeft: 6,
            fontSize: 11,
          }}
        >
          Type into the search to find {heading}
        </div>
      )}

      <div style={{ marginLeft: 6 }}>{AllItemElements}</div>

      {isPlayerFilter && !!AllItemElements.length && !!searchFilter && (
        <Button style={{ marginTop: ".5rem" }} onClick={focusAndClearSearch}>
          Add Another Player
        </Button>
      )}
    </div>
  );
};

export default OptionList;
